import React, { FC, useEffect, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import { AttributeTemplate } from '../../../../api/template';
import { ActionType } from '../index';
import TemplateVersionModal from './TemplateVersionModal';
import styles from './index.module.scss';

export interface SelectDevicesProps {
  value?: AttributeTemplate;
  onChange?: (value?: AttributeTemplate) => void;
  rootMcid?: string;
  deviceType?: number[];
  actionType?: ActionType;
  templateId?: number;
}

const SelectDevices: FC<SelectDevicesProps> = ({ value, onChange, rootMcid, deviceType, actionType, templateId }) => {
  const [visible, setVisible] = useState<boolean>(false);

  const [dataSource, setDataSource] = useState<AttributeTemplate>();
  const [modalApi, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    setDataSource(value);
  }, [value]);

  const onAdd = () => {
    if (rootMcid === undefined) {
      modalApi.warning({
        title: '请先选择所属租户',
      });
      return;
    }
    if (deviceType === undefined) {
      modalApi.warning({
        title: '请先选择所属类目',
      });
      return;
    }
    setVisible(true);
  };

  const onCancel = () => {
    setDataSource(value);
    setVisible(false);
  };

  const onOk = () => {
    onChange?.(dataSource);
    setVisible(false);
  };

  return (
    <>
      <Space>
        {value !== undefined && <div className={styles.version}>{value?.version ?? ''}</div>}
        <Button type="link" onClick={onAdd} disabled={actionType === ActionType.ADD}>
          {value === undefined ? '请' : '重新'}选择
        </Button>
      </Space>
      <Modal
        className={styles.modal}
        title="版本选择"
        destroyOnClose
        open={visible}
        onOk={onOk}
        onCancel={onCancel}
        width={1000}
      >
        <TemplateVersionModal
          rootMcid={rootMcid}
          deviceType={deviceType}
          actionType={actionType}
          templateId={templateId}
          onChange={setDataSource}
          value={dataSource}
        />
      </Modal>
      {modalContextHolder}
    </>
  );
};

export default SelectDevices;
